// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress--1-0","progress__label":"progress__label--3Hu"};